import * as React from "react";
import PageHeaderView from "../body/PageHeaderView";
import PageContentView from "../body/PageContentView";
import AddContactForm from "./form/create/AddContactForm";
import {withRouter} from "react-router-dom";
import {RouteComponentProps} from "react-router";
import Routes from "../../navigation/route/Route";
import {MxpContactCreation} from "../../utils/MixpanelHelper";
import {Boxed} from "../../hiberUiKit/src/molecules/Boxed/Boxed";

type Props = RouteComponentProps<any>;

/**
 * Create contact view.
 */
class CreateContact extends React.PureComponent <Props, {}> {
	mxpEvent: MxpContactCreation;

	constructor(props: Props) {
		super(props);
		this.onSuccess = this.onSuccess.bind(this);
		this.onCancel = this.onCancel.bind(this);
		this.mxpEvent = new MxpContactCreation();
	}

	render() {
		return (
			<Boxed>
				<PageHeaderView header={"Create new contact"}/>
				<PageContentView>
					<AddContactForm onSuccessIndividual={this.onSuccess}
									onCancel={this.onCancel}/>
				</PageContentView>
			</Boxed>
		);
	}

	/**
	 * On successfully added contact.
	 */
	private onSuccess() {
		this.mxpEvent.success();
		this.props.history.push(Routes.ContactsList);
	}

	/**
	 * Add contact form cancel button handler.
	 */
	private onCancel() {
		this.mxpEvent.failure();
		this.props.history.goBack();
	}
}

export default withRouter(CreateContact);